module.exports = __webpack_public_path__ + "frontend/images/faq/screen-payment-actions-xs-130e6335aa205a6dc5ed51571eddea2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-payment-actions-xs.jpg
// module id = 344
// module chunks = 2